/**
 * @function preventFromScroll
 * @description Prevent scroll on body
 *
 */

export const preventFromScroll = (): any => {

    const body = document.querySelector('body');
    body.classList.toggle('prevent-scroll');

};
